import { Flex, Text, Image, Spacer, Link, Hide } from "@chakra-ui/react";
import React, { memo, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import { listSwiperData } from "@/constants/alohainfo-contants";
// import required modules
import { EffectCoverflow } from "swiper";
import { TwitterIcon } from "@/icon/TwitterIcon";
import PaginationComponent from "./pagination";
export default memo(function SwiperComponent() {
   const [activeIndex, setActiveIndex] = useState(0);
   return (
      <Flex
         userSelect="none"
         alignItems={"center"}
         pos={'relative'}
         mt={{base:'0px',BREAK_PAD:'15px',BREAK_LPC:"30px"}}
         w={'full'}
         flexDir={"column"}
         justifyItems="center">
         <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            initialSlide={2}
            slidesPerView={"auto"}
            slideToClickedSlide={true}
            onSlideChange={(item) => {
               setActiveIndex(item.activeIndex);
            }}
            coverflowEffect={{
               rotate: 0,
               depth: 350,
               slideShadows: false,
            }}
            modules={[EffectCoverflow]}
            className="mySwiper">
            {listSwiperData.map((item, _index) => {
               return (
                  <SwiperSlide key={item.title}>
                     <Flex
                        flexDir={"column"}
                        bg="white"
                        p={"20px"}
                        boxShadow={"0px 16px 40px 0px rgba(0,0,0,0.1)"}
                        borderRadius={12}>
                        <Link href={item.twitter_url} isExternal>
                           <Flex>
                              <Image
                                 alt={item.title}
                                 style={{ width: "44px", height: "44px" }}
                                 borderRadius="full"
                                 src={process.env.REACT_APP_PUBLIC_URL + item.icon}
                              />
                              <Flex flexDir={"column"}>
                                 <Text variant={"16_black_bold"} ml={"10px"} lineHeight={"24px"}>
                                    {item.title}
                                 </Text>
                                 <Flex flexDir={"row"}>
                                    <Text fontSize={14} color={"#999"} ml={"10px"}>
                                       {item.at}
                                    </Text>
                                    <Text mx={"4px"} variant={"14_black_bold"}>
                                       ·
                                    </Text>
                                    <Text fontSize={"14px"} color={"blue.500"} fontFamily={"Arial-BoldMT"}>
                                       Follow
                                    </Text>
                                 </Flex>
                              </Flex>
                              <Spacer />
                              <TwitterIcon boxSize={"24px"} cursor={"pointer"} color="blue.500"/>
                           </Flex>
                        </Link>

                        <Text mt={"10px"} fontSize={{base:"16px",BREAK_LPC:'20px'}} color={"black"} lineHeight={"26px"}>
                           {item.info}
                        </Text>
                        <Image
                           alt={item.title}
                           borderRadius={"8px"}     
                           src={process.env.REACT_APP_PUBLIC_URL + item.pic}
                           boxSize={{base:'300px',BREAK_LPC:'330px'}}
                           mt={"10px"}
                        />
                        <Link
                           href={item.twitter_url}
                           w={"full"}
                           isExternal
                           fontSize={14}
                           color="blue.500"
                           fontFamily={"Arial-BoldMT"}
                           h={"32px"}
                           mt={"8px"}
                           textAlign="center"
                           lineHeight={"32px"}
                           bg={"white"}
                           _hover={{color:{base:"blue.500",BREAK_LPC:'blue.600'}}}
                           borderRadius={"16px"}
                           border={"1px solid #E6E6E6"}>
                           Explore what’s happening on Twitter
                        </Link>
                     </Flex>
                  </SwiperSlide>
               );
            })}
         </Swiper>
         <Hide above="BREAK_LPC">
            <PaginationComponent activeIndex={activeIndex} />
         </Hide>
      </Flex>
   );
});
